import PropTypes from "prop-types";
import { Calendar, FileText, Package } from "lucide-react";
import { Card, CardHeader, MetadataField, Divider, Badge } from "../ui";

const InvoiceInfo = ({ metadata }) => {
  const display = metadata?.display || {};
  const hasInfo = display.invoice_number || display.bill_to || display.due_date;

  if (!hasInfo) return null;

  const isOverdue = display.due_date && new Date(display.due_date) < new Date();

  return (
    <Card className="mb-4">
      <div className="px-4 sm:px-6 pt-4 sm:pt-5 pb-2 sm:pb-3">
        <h3 className="text-sm sm:text-base font-bold" style={{ color: "#3B3B3B" }}>
          Invoice Details
        </h3>
      </div>
      <div className="px-4 sm:px-6 pb-4 sm:pb-5">
        <div className="space-y-1">
          {display.invoice_number && (
            <div className="py-2 sm:py-3">
              <div className="flex items-center gap-2 mb-1">
                <FileText className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" style={{ color: "#515164" }} />
                <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
                  Invoice Number
                </span>
              </div>
              <div className="pl-5 sm:pl-6">
                <span className="text-xs sm:text-sm font-semibold" style={{ color: "#01793B" }}>
                  {display.invoice_number}
                </span>
              </div>
            </div>
          )}

          {display.bill_to && (
            <MetadataField
              icon={Package}
              label="Bill To"
              value={display.bill_to}
              isMultiline
            />
          )}

          <Divider />

          {display.invoice_date && (
            <MetadataField
              icon={Calendar}
              label="Invoice Date"
              value={new Date(display.invoice_date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            />
          )}

          {display.issued_date && (
            <MetadataField
              icon={Calendar}
              label="Issued Date"
              value={new Date(display.issued_date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            />
          )}

          {display.due_date && (
            <div className="flex justify-between items-center py-2 sm:py-3 gap-2">
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <Calendar
                  className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0"
                  style={{
                    color: isOverdue ? "#DC2626" : "#515164",
                  }}
                />
                <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
                  Due Date
                </span>
              </div>
              <Badge
                variant={isOverdue ? "error" : "success"}
              >
                {new Date(display.due_date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
                {isOverdue && " (Overdue)"}
              </Badge>
            </div>
          )}

          {display.payment_terms && (
            <MetadataField label="Payment Terms" value={display.payment_terms} />
          )}

          {display.notes && (
            <MetadataField label="Notes" value={display.notes} isMultiline />
          )}
        </div>
      </div>
    </Card>
  );
};

InvoiceInfo.propTypes = {
  metadata: PropTypes.shape({
    display: PropTypes.shape({
      invoice_number: PropTypes.string,
      bill_to: PropTypes.string,
      invoice_date: PropTypes.string,
      issued_date: PropTypes.string,
      due_date: PropTypes.string,
      payment_terms: PropTypes.string,
      notes: PropTypes.string,
    }),
  }),
};

export default InvoiceInfo;
